import React from 'react';
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';

const LIST_WIDTH = '100%';
const LIST_HEIGHT = 140;

const InfiniteLoaderList = ({
  children,
  options,
  isItemLoaded,
  hasNextPage,
  isNextPageLoading,
  loadNextPage,
  itemSize,
}) => {
  const itemCount = hasNextPage
    ? (options || []).length + 1
    : (options || []).length;
  const loadMoreItems =
    isNextPageLoading || !loadNextPage ? () => {} : loadNextPage;
  const ITEM_SIZE = itemSize || 30;

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={loadMoreItems}
    >
      {({ onItemsRendered, ref }) => (
        <List
          height={LIST_HEIGHT}
          itemCount={itemCount}
          itemSize={ITEM_SIZE}
          onItemsRendered={onItemsRendered}
          ref={ref}
          width={LIST_WIDTH}
        >
          {children}
        </List>
      )}
    </InfiniteLoader>
  );
};

export default InfiniteLoaderList;
